(function() { window.GUID_d931dea3_bfa5_4d1b_bc31_30de974cd59b = { getGuid: function() { return "d931dea3-bfa5-4d1b-bc31-30de974cd59b"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    class RacingBarChartSection {
                        static get instance() {
                            if (!RacingBarChartSection._instance)
                                RacingBarChartSection._instance = new RacingBarChartSection();
                            return RacingBarChartSection._instance;
                        }
                        constructor() {
                            this._racingBarCharts = [];
                        }
                        static getData(accordionContentId, overrideExisting = false) {
                            const { instance } = this;
                            if (overrideExisting) {
                                this.registerChart(accordionContentId);
                            }
                            const registeredChart = instance._racingBarCharts.find((x) => x.accordionContentId == accordionContentId);
                            return registeredChart ? registeredChart.racingBarChart : null;
                        }
                        static getHighlightedColors(accordionContentId) {
                            const racingBarChart = this.getData(accordionContentId);
                            const { params: { highlightedOpponentIds }, } = racingBarChart;
                            const divergentColorsCount = Object.keys(CS.Helper.DataVisualizationHelper.DIVERGENT_PALETTE).length;
                            return highlightedOpponentIds.length <= 1
                                ? [CS.Helper.DataVisualizationHelper.MAIN_COLOR]
                                : divergentColorsCount > highlightedOpponentIds.length
                                    ? Array.from({ length: highlightedOpponentIds.length }).map((color, index) => {
                                        return CS.Helper.DataVisualizationHelper.DEFAULT_COLOR;
                                    })
                                    : Object.keys(CS.Helper.DataVisualizationHelper.DIVERGENT_PALETTE)
                                        .map((key) => {
                                        return CS.Helper.DataVisualizationHelper.DIVERGENT_PALETTE[key];
                                    })
                                        .slice(0, highlightedOpponentIds.length);
                        }
                        static updateDatasetsColors(accordionContentId, sortedDatasets, followedOpponentId) {
                            const racingBarChart = this.getData(accordionContentId);
                            const { params: { highlightedOpponentIds }, } = racingBarChart;
                            let highlightedColorIndex = 0;
                            const highlightedColors = this.getHighlightedColors(accordionContentId);
                            sortedDatasets.forEach((dataset, index) => {
                                dataset.data.forEach((dataPoint, index) => {
                                    const highlightedColor = highlightedColors[highlightedColorIndex];
                                    //const isHighlighted = highlightedOpponentIds.includes(
                                    //    dataPoint.EntityBaseId
                                    //) || dataPoint.EntityBaseId == followedOpponentId;
                                    const isHighlighted = dataPoint.EntityBaseId == followedOpponentId;
                                    const BackgroundColor = isHighlighted
                                        ? `${highlightedColor}80`
                                        : `${CS.Helper.DataVisualizationHelper.DEFAULT_COLOR}80`;
                                    const BorderColor = isHighlighted
                                        ? `${highlightedColor}`
                                        : `${CS.Helper.DataVisualizationHelper.DEFAULT_COLOR}`;
                                    if (isHighlighted) {
                                        highlightedColorIndex++;
                                    }
                                    dataPoint.BackgroundColor = BackgroundColor;
                                    dataPoint.BorderColor = BorderColor;
                                    dataPoint.IsHighlighted = isHighlighted;
                                });
                                dataset.backgroundColor = dataset.data.map((dataPoint) => {
                                    return dataPoint.BackgroundColor;
                                });
                                dataset.borderColor = dataset.data.map((dataPoint) => {
                                    return dataPoint.BorderColor;
                                });
                            });
                        }
                        static getSortedDatasets(accordionContentId, datasets) {
                            const racingBarChart = this.getData(accordionContentId);
                            const { params: { rankingStatSortDirection }, } = racingBarChart;
                            return datasets.map((dataset) => {
                                const data = dataset.Stats.map((stat, index) => {
                                    const { Value, DisplayName, DisplayValue, RankingValue, OpponentImageUrl, EntityBaseId, IsTransitionStat, } = stat;
                                    return {
                                        x: DisplayValue,
                                        //y: DisplayName,
                                        y: `${EntityBaseId}`,
                                        Value,
                                        DisplayName,
                                        DisplayValue,
                                        RankingValue,
                                        OpponentImageUrl,
                                        EntityBaseId,
                                        BackgroundColor: "white",
                                        BorderColor: "white",
                                        IsTransitionStat,
                                    };
                                }).sort((a, b) => {
                                    if (rankingStatSortDirection == "ascending") {
                                        return a.RankingValue - b.RankingValue;
                                    }
                                    return b.RankingValue - a.RankingValue;
                                });
                                return {
                                    data: data,
                                    backgroundColor: data.map((dataPoint) => {
                                        return dataPoint.BackgroundColor;
                                    }),
                                    borderColor: data.map((dataPoint) => {
                                        return dataPoint.BorderColor;
                                    }),
                                    borderWidth: 1,
                                    borderRadius: 5,
                                    IsTransitionDataset: dataset.IsTransitionDataset,
                                    DatasetId: `${dataset.Date}-${Math.random()}`,
                                };
                            });
                        }
                        static setChartHeaderDatesLabels(accordionContentId, datasetIndex, datasets, sortedDatasets, sortedDatasetsInverted) {
                            const racingBarChart = this.getData(accordionContentId);
                            const { elements: { $currentDateLabel, $nextDateLabel, $previousDateLabel }, } = racingBarChart;
                            const nextDatasetIndex = datasetIndex < datasets.length - 1 ? datasetIndex + 1 : datasetIndex;
                            const previousDatasetIndex = datasetIndex > 0 ? datasetIndex - 1 : datasetIndex;
                            const nextDatasetExists = nextDatasetIndex != datasetIndex;
                            const previousDatasetExists = previousDatasetIndex != datasetIndex;
                            const dataset = datasets[datasetIndex];
                            $currentDateLabel.text(`${dataset.Date.trim()}`);
                            if (racingBarChart.params.shouldDisplayWeekNumber &&
                                dataset.DateSubtitle != null &&
                                dataset.DateSubtitle.trim() != "") {
                                $currentDateLabel.text(`${dataset.DateSubtitle.trim()} – ${dataset.Date.trim()}`);
                            }
                            const { nextRealDatasetIndex, previousRealDatasetIndex } = this.findNextAndPreviousRealDatasetIndexes(sortedDatasets, datasetIndex, sortedDatasetsInverted);
                            if (nextDatasetExists) {
                                const nextDataset = datasets[nextRealDatasetIndex];
                                const nextDateLabel = nextDataset.Date;
                                $nextDateLabel.text(`${nextDateLabel}`);
                                CS.Helper.removeInlineStyleProps($nextDateLabel, [
                                    "background-color",
                                    "border",
                                    "opacity",
                                ]);
                            }
                            else {
                                $nextDateLabel.text(" ");
                                $nextDateLabel.css({
                                    "background-color": "transparent",
                                    border: "unset",
                                    opacity: "0",
                                });
                            }
                            if (previousDatasetExists) {
                                const previousDataset = datasets[previousRealDatasetIndex];
                                const previousDateLabel = previousDataset.Date;
                                $previousDateLabel.text(`${previousDateLabel}`);
                                CS.Helper.removeInlineStyleProps($previousDateLabel, [
                                    "background-color",
                                    "border",
                                    "opacity",
                                ]);
                            }
                            else {
                                $previousDateLabel.text(" ");
                                $previousDateLabel.css({
                                    "background-color": "transparent",
                                    border: "unset",
                                    opacity: "0",
                                });
                            }
                        }
                        static getFollowedOpponentInitialIndex(followedOpponentId, datasets) {
                            var _a;
                            const followedEntityBaseIdIndexes = followedOpponentId == null
                                ? []
                                : (_a = datasets.map((d) => d.data.findIndex((s) => s.EntityBaseId == followedOpponentId))) !== null && _a !== void 0 ? _a : [];
                            const followedEntityBaseIdInitalIndex = followedEntityBaseIdIndexes.length > 0
                                ? followedEntityBaseIdIndexes[0]
                                : -1;
                            return followedEntityBaseIdInitalIndex;
                        }
                        static findNextAndPreviousRealDatasetIndexes(sortedDatasets, datasetIndex, sortedDatasetsInverted) {
                            if (datasetIndex >= sortedDatasets.length) {
                                datasetIndex = sortedDatasets.length - 1;
                            }
                            if (datasetIndex < 0) {
                                datasetIndex = 0;
                            }
                            const currentDataset = sortedDatasets[datasetIndex];
                            let nextRealDatasetIndex = sortedDatasets.findIndex((dataset, index) => {
                                return index > datasetIndex && !dataset.IsTransitionDataset;
                            });
                            if (nextRealDatasetIndex == -1) {
                                nextRealDatasetIndex = sortedDatasets.length - 1;
                            }
                            const datasetIndexInverted = sortedDatasetsInverted.findIndex((dataset, index) => {
                                return dataset.DatasetId == currentDataset.DatasetId;
                            });
                            let previousRealDatasetIndexInverted = sortedDatasetsInverted.findIndex((dataset, index) => {
                                return index > datasetIndexInverted && !dataset.IsTransitionDataset;
                            });
                            let previousRealDatasetIndex = -1;
                            if (previousRealDatasetIndexInverted > -1) {
                                const previousRealDatasetInverted = sortedDatasetsInverted[previousRealDatasetIndexInverted];
                                previousRealDatasetIndex = sortedDatasets.findIndex((dataset, index) => {
                                    return dataset.DatasetId == previousRealDatasetInverted.DatasetId;
                                });
                            }
                            return {
                                nextRealDatasetIndex,
                                previousRealDatasetIndex,
                            };
                        }
                        static udpateButtonsUI(nextDatasetIndex, $leftButton, $rightButton, $startButton, $continueButton, $resetButton, $stopButton, sortedDatasetsLength) {
                            const currentDatasetIsFirst = nextDatasetIndex.value == 1;
                            const currentDatasetIsLast = nextDatasetIndex.value >= sortedDatasetsLength;
                            if (currentDatasetIsFirst || currentDatasetIsLast) {
                                if (currentDatasetIsFirst) {
                                    CS.Helper.disableButtons([$leftButton]);
                                    CS.Helper.enableButtons([$rightButton]);
                                    CS.Helper.showButtons([$startButton]);
                                    CS.Helper.hideButtons([$continueButton, $resetButton, $stopButton]);
                                }
                                if (currentDatasetIsLast) {
                                    CS.Helper.disableButtons([$rightButton]);
                                    CS.Helper.enableButtons([$leftButton]);
                                    CS.Helper.showButtons([$resetButton]);
                                    CS.Helper.hideButtons([$startButton, $continueButton, $stopButton]);
                                }
                            }
                            else {
                                CS.Helper.enableButtons([$leftButton, $rightButton]);
                                CS.Helper.hideButtons([$startButton, $stopButton]);
                                CS.Helper.showButtons([$continueButton, $resetButton]);
                            }
                        }
                        static bindChartControlElements(accordion, handleChartAnimationStart, handleChartAnimationContinue, handleChartAnimationStopOnNextNonTransitionDataset, handleChartAnimationStop, handleChartReset, handleChartScrollRight, handleChartScrollLeft, handleChartScrollTop, handleChartScrollBottom, isDemoMode) {
                            if (!CS.CommonData.Current.IsPremium && !isDemoMode) {
                                return;
                            }
                            accordion.$Content.offon("click.RacingBarChartSectionViewModelStartButton", `#${RacingBarChartSection.START_BUTTON_ID_PREFIX}-${accordion.ContentId}`.toLowerCase(), () => handleChartAnimationStart());
                            accordion.$Content.offon("click.RacingBarChartSectionViewModelContinueButton", `#${RacingBarChartSection.CONTINUE_BUTTON_ID_PREFIX}-${accordion.ContentId}`.toLowerCase(), () => handleChartAnimationContinue());
                            accordion.$Content.offon("click.RacingBarChartSectionViewModelStopButton", `#${RacingBarChartSection.STOP_BUTTON_ID_PREFIX}-${accordion.ContentId}`.toLowerCase(), () => handleChartAnimationStop());
                            accordion.$Content.offon("click.RacingBarChartSectionViewModelResetButton", `#${RacingBarChartSection.RESET_BUTTON_ID_PREFIX}-${accordion.ContentId}`.toLowerCase(), () => handleChartReset());
                            accordion.$Content.offon("click.RacingBarChartSectionViewModelRightButton", `#${RacingBarChartSection.RIGHT_ARROW_BUTTON_ID_PREFIX}-${accordion.ContentId}`.toLowerCase(), () => handleChartScrollRight());
                            accordion.$Content.offon("click.RacingBarChartSectionViewModelNextDate", `#RacingBarChartSectionViewModelNextDate-${accordion.ContentId}`, () => handleChartScrollRight());
                            accordion.$Content.offon("click.RacingBarChartSectionViewModelLeftButton", `#${RacingBarChartSection.LEFT_BUTTON_ID_PREFIX}-${accordion.ContentId}`.toLowerCase(), () => handleChartScrollLeft());
                            accordion.$Content.offon("click.RacingBarChartSectionViewModelPreviousDate", `#RacingBarChartSectionViewModelPreviousDate-${accordion.ContentId}`, () => handleChartScrollLeft());
                            accordion.$Content.offon("click.RacingBarChartSectionViewModelTopButton", `#${RacingBarChartSection.TOP_BUTTON_ID_PREFIX}-${accordion.ContentId}`.toLowerCase(), () => handleChartScrollTop(1));
                            accordion.$Content.offon("click.RacingBarChartSectionViewModelBottomButton", `#${RacingBarChartSection.BOTTOM_BUTTON_ID_PREFIX}-${accordion.ContentId}`.toLowerCase(), () => handleChartScrollBottom(1));
                            accordion.$Content.offon("click.RacingBarChartSectionViewModelTopButtonMore", `#${RacingBarChartSection.TOP_BUTTON_MORE_ID_PREFIX}-${accordion.ContentId}`.toLowerCase(), () => handleChartScrollTop(10));
                            accordion.$Content.offon("click.RacingBarChartSectionViewModelBottomButtonMore", `#${RacingBarChartSection.BOTTOM_BUTTON_MORE_ID_PREFIX}-${accordion.ContentId}`.toLowerCase(), () => handleChartScrollBottom(10));
                        }
                        static setProgressBarDatesLabels(allDates, $datesSpanContainer) {
                            const displayedDates = [];
                            if (allDates.length >= 5) {
                                displayedDates.push(allDates[0]);
                                displayedDates.push(allDates[Math.floor((allDates.length * 1) / 4)]);
                                displayedDates.push(allDates[Math.floor((allDates.length * 2) / 4)]);
                                displayedDates.push(allDates[Math.floor((allDates.length * 3) / 4)]);
                                displayedDates.push(allDates[allDates.length - 1]);
                            }
                            else if (allDates.length >= 4) {
                                displayedDates.push(allDates[Math.floor((allDates.length * 0) / 3)]);
                                displayedDates.push(allDates[Math.floor((allDates.length * 1) / 3)]);
                                displayedDates.push(allDates[Math.floor((allDates.length * 2) / 3)]);
                                displayedDates.push(allDates[Math.floor((allDates.length * 3) / 3)]);
                            }
                            else if (allDates.length >= 3) {
                                displayedDates.push(allDates[Math.floor((allDates.length * 0) / 2)]);
                                displayedDates.push(allDates[Math.floor((allDates.length * 1) / 2)]);
                                displayedDates.push(allDates[Math.floor((allDates.length * 2) / 2)]);
                            }
                            else {
                                displayedDates.push(allDates[0]);
                                displayedDates.push(allDates[allDates.length - 1]);
                            }
                            displayedDates.forEach((date) => {
                                $datesSpanContainer.append(`<span class="date">${date}</span>`);
                            });
                        }
                        static computeIntervalTimeout(distanceUntilNextRealDataset) {
                            if (distanceUntilNextRealDataset > 7) {
                                const newTimeout = (this.intervalTimeout * 20) / distanceUntilNextRealDataset;
                                return newTimeout > this.intervalTimeout
                                    ? this.intervalTimeout
                                    : newTimeout;
                            }
                            else {
                                return this.intervalTimeout;
                            }
                        }
                        static findCurrentDatasetIndex(chart, sortedDatasets) {
                            const currentDataset = chart.data.datasets[0];
                            const currentDatasetIndex = sortedDatasets.findIndex((dataset) => dataset.DatasetId == currentDataset.DatasetId);
                            return currentDatasetIndex;
                        }
                        static registerChart(accordionContentId) {
                            const { instance } = this;
                            const alreadyRegistered = instance._racingBarCharts.find((x) => x.accordionContentId == accordionContentId);
                            if (alreadyRegistered) {
                                instance._racingBarCharts = instance._racingBarCharts.filter((x) => x.accordionContentId != accordionContentId);
                            }
                            const racingBarChart = this.parseFromDOM(accordionContentId);
                            instance._racingBarCharts.push({ accordionContentId, racingBarChart });
                        }
                        static parseFromDOM(accordionContentId) {
                            const { instance } = this;
                            const $dataInput = $(`#${this.DATA_INPUT_ID_PREFIX}-${accordionContentId}`);
                            if (!$dataInput.length) {
                                return null;
                            }
                            const $dateInputs = $(`[id*="${this.DATE_INPUT_ID_PREFIX}-${accordionContentId}"]`);
                            if (!$dateInputs.length) {
                                return null;
                            }
                            const $progressBar = $(`#${this.PROGRESS_BAR_ID_PREFIX}-${accordionContentId}`);
                            const $datesContainer = $(`#${this.DATES_CONTAINER_ID_PREFIX}-${accordionContentId}`);
                            const $previousDateLabel = $datesContainer.find(".previous-date");
                            //const $currentDateLabel = $datesContainer.find(".current-date");
                            const $currentDateLabel = $(`#RacingBarChartSectionViewModelCurrentDateCURRENT-${accordionContentId}`);
                            const $nextDateLabel = $datesContainer.find(".next-date");
                            const $startButton = $(`#${this.START_BUTTON_ID_PREFIX}-${accordionContentId}`.toLowerCase());
                            const $continueButton = $(`#${this.CONTINUE_BUTTON_ID_PREFIX}-${accordionContentId}`.toLowerCase());
                            const $stopButton = $(`#${this.STOP_BUTTON_ID_PREFIX}-${accordionContentId}`.toLowerCase());
                            const $resetButton = $(`#${this.RESET_BUTTON_ID_PREFIX}-${accordionContentId}`.toLowerCase());
                            const $leftButton = $(`#${this.LEFT_BUTTON_ID_PREFIX}-${accordionContentId}`.toLowerCase());
                            const $rightButton = $(`#${this.RIGHT_ARROW_BUTTON_ID_PREFIX}-${accordionContentId}`.toLowerCase());
                            const $topButton = $(`#${this.TOP_BUTTON_ID_PREFIX}-${accordionContentId}`.toLowerCase());
                            const $bottomButton = $(`#${this.BOTTOM_BUTTON_ID_PREFIX}-${accordionContentId}`.toLowerCase());
                            const $topButtonMore = $(`#${this.TOP_BUTTON_MORE_ID_PREFIX}-${accordionContentId}`.toLowerCase());
                            const $bottomButtonMore = $(`#${this.BOTTOM_BUTTON_MORE_ID_PREFIX}-${accordionContentId}`.toLowerCase());
                            const $progressBarContainer = $(`#${this.PROGRESS_BAR_CONTAINER_ID_PREFIX}-${accordionContentId}`);
                            const elements = {
                                $dataInput,
                                $progressBar,
                                $datesContainer,
                                $previousDateLabel,
                                $currentDateLabel,
                                $nextDateLabel,
                                $startButton,
                                $continueButton,
                                $stopButton,
                                $resetButton,
                                $leftButton,
                                $rightButton,
                                $topButton,
                                $bottomButton,
                                $topButtonMore,
                                $bottomButtonMore,
                                $progressBarContainer,
                            };
                            let datasets = [];
                            if (!$dateInputs.length) {
                                return null;
                            }
                            $dateInputs.each((index, element) => {
                                const $element = $(element);
                                const inputVal = $element.val();
                                if (inputVal != null && inputVal.trim() != "") {
                                    const parsedVal = JSON.parse(inputVal);
                                    const { Date, Stats, IsTransitionDataset, DateSubtitle, DecimalCount, DecimalCount1, WeekNo, } = parsedVal;
                                    if (Date && Stats) {
                                        datasets.push({
                                            Date,
                                            Stats,
                                            IsTransitionDataset,
                                            DateSubtitle,
                                            DecimalCount,
                                            DecimalCount1,
                                            WeekNo,
                                        });
                                    }
                                }
                            });
                            const dataPointsCount = datasets.length;
                            if (!dataPointsCount) {
                                return null;
                            }
                            const opponentsCount = datasets[0].Stats.length;
                            if (dataPointsCount >= 50) {
                                this.intervalTimeout = 1000;
                            }
                            else {
                                if (opponentsCount <= 15) {
                                    this.intervalTimeout = 1500;
                                }
                                else {
                                    this.intervalTimeout = 2500;
                                }
                            }
                            const dataInputVal = $dataInput.val();
                            if (dataInputVal == null) {
                                return null;
                            }
                            const dataRaw = JSON.parse(dataInputVal);
                            let highlightedOpponentIds = [];
                            if (dataRaw.HighlightedEntityBaseIds != null &&
                                dataRaw.HighlightedEntityBaseIds.trim() != "") {
                                highlightedOpponentIds = dataRaw.HighlightedEntityBaseIds.split(",").map((x) => parseInt(x));
                            }
                            let followedOpponentId = null;
                            if (dataRaw.FollowedEntityBaseId != null &&
                                dataRaw.FollowedEntityBaseId.trim() != "") {
                                followedOpponentId = parseInt(dataRaw.FollowedEntityBaseId);
                            }
                            let rankingStatSortDirection = "ascending";
                            if (dataRaw.RankingStatSortingOrder != null &&
                                dataRaw.RankingStatSortingOrder.trim() != "") {
                                rankingStatSortDirection =
                                    dataRaw.RankingStatSortingOrder.toLowerCase();
                            }
                            let entityType = null;
                            if (dataRaw.EntityType != null) {
                                entityType = dataRaw.EntityType;
                            }
                            return {
                                elements,
                                data: {
                                    datasets,
                                },
                                params: {
                                    intervalTimeout: new RacingBarChartNumberParam(this.intervalTimeout),
                                    colorAnimationDuration: this.COLOR_ANIMATION_DURATION,
                                    barAnimationDuration: this.intervalTimeout,
                                    maxDisplayedOpponentsCount: this.MAX_DISPLAYED_OPPONENTS_COUNT,
                                    minDisplayedOpponentIndex: new RacingBarChartNumberParam(this.MIN_DISPLAYED_OPPONENT_INDEX),
                                    maxDisplayedOpponentIndex: new RacingBarChartNumberParam(this.MAX_DISPLAYED_OPPONENT_INDEX),
                                    highlightedOpponentIds,
                                    followedOpponentId: new RacingBarChartParam(followedOpponentId),
                                    statGroupId: dataRaw.StatGroupId,
                                    statFieldId: dataRaw.StatFieldId,
                                    displayStatFieldId: dataRaw.DisplayStatFieldId,
                                    rankingStatFieldId: dataRaw.RankingStatFieldId,
                                    rankingStatSortDirection,
                                    entityType,
                                    shouldFollowOpponent: new RacingBarChartParam(followedOpponentId != null),
                                    interval: new RacingBarChartParam(null),
                                    nextDatasetIndex: new RacingBarChartNumberParam(1),
                                    previousDatasetIndex: new RacingBarChartNumberParam(-1),
                                    updatesCount: new RacingBarChartNumberParam(0),
                                    totalUpdatesCount: datasets.length - 1,
                                    shouldStartAnimationAutomatically: !$startButton.length,
                                    forceStopOnNextRealDataset: new RacingBarChartParam(false),
                                    decimalsCount: datasets[0].DecimalCount1,
                                    decimalsCount1: datasets[0].DecimalCount1,
                                    shouldDisplayWeekNumber: dataRaw.ShouldDisplayWeekNumber,
                                },
                            };
                        }
                    }
                    RacingBarChartSection.intervalTimeout = 1000;
                    RacingBarChartSection.COLOR_ANIMATION_DURATION = RacingBarChartSection.intervalTimeout / 5;
                    //public static readonly BAR_ANIMATION_DURATION =
                    //    RacingBarChartSection.intervalTimeout * 1;
                    //RacingBarChartSection.INTERVAL_TIMEOUT / 1.5;
                    //RacingBarChartSection.INTERVAL_TIMEOUT * 3;
                    RacingBarChartSection.MAX_DISPLAYED_OPPONENTS_COUNT = 10;
                    RacingBarChartSection.MIN_DISPLAYED_OPPONENT_INDEX = 0;
                    RacingBarChartSection.MAX_DISPLAYED_OPPONENT_INDEX = RacingBarChartSection.MIN_DISPLAYED_OPPONENT_INDEX +
                        RacingBarChartSection.MAX_DISPLAYED_OPPONENTS_COUNT -
                        1;
                    RacingBarChartSection.DATA_INPUT_ID_PREFIX = "RacingBarChartSectionViewModelData";
                    RacingBarChartSection.DATE_INPUT_ID_PREFIX = "RacingBarChartSectionViewModelDate";
                    RacingBarChartSection.PROGRESS_BAR_ID_PREFIX = "RacingBarChartSectionViewModelProgressBar";
                    RacingBarChartSection.PROGRESS_BAR_CONTAINER_ID_PREFIX = "RacingBarChartSectionViewModelProgressBarContainer";
                    RacingBarChartSection.DATES_CONTAINER_ID_PREFIX = "RacingBarChartSectionViewModelCurrentDate";
                    RacingBarChartSection.START_BUTTON_ID_PREFIX = "button-RacingBarChartSectionViewModelStartButton";
                    RacingBarChartSection.CONTINUE_BUTTON_ID_PREFIX = "button-RacingBarChartSectionViewModelContinueButton";
                    RacingBarChartSection.STOP_BUTTON_ID_PREFIX = "button-RacingBarChartSectionViewModelStopButton";
                    RacingBarChartSection.RESET_BUTTON_ID_PREFIX = "button-RacingBarChartSectionViewModelResetButton";
                    RacingBarChartSection.LEFT_BUTTON_ID_PREFIX = "button-RacingBarChartSectionViewModelArrowLeftButton";
                    RacingBarChartSection.RIGHT_ARROW_BUTTON_ID_PREFIX = "button-RacingBarChartSectionViewModelArrowRightButton";
                    RacingBarChartSection.TOP_BUTTON_ID_PREFIX = "button-RacingBarChartSectionViewModelArrowTopButton";
                    RacingBarChartSection.TOP_BUTTON_MORE_ID_PREFIX = "button-RacingBarChartSectionViewModelArrowTopButtonMore";
                    RacingBarChartSection.BOTTOM_BUTTON_ID_PREFIX = "button-RacingBarChartSectionViewModelArrowBottomButton";
                    RacingBarChartSection.BOTTOM_BUTTON_MORE_ID_PREFIX = "button-RacingBarChartSectionViewModelArrowBottomButtonMore";
                    WallSections.RacingBarChartSection = RacingBarChartSection;
                    class RacingBarChartParam {
                        constructor(defaultValue) {
                            this.value = defaultValue;
                            this.initialValue = defaultValue;
                        }
                        setValue(value) {
                            this.value = value;
                        }
                        resetValue() {
                            this.value = this.initialValue;
                        }
                    }
                    class RacingBarChartNumberParam extends RacingBarChartParam {
                        incrementValue(value = 1) {
                            this.value += value;
                        }
                        decrementValue(value = 1) {
                            this.value -= value;
                        }
                    }
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=section.js.map
